import { CustomButton } from 'components/ui'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { formatToDecimal } from 'utils/formatUnits'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Dropdown, { DropDownItem } from 'components/ui/Dropdown/Dropdown'
import ModalDeleteArticuloAdmin from './ModalDeleteArticuloAdmin'
import { useUpdateSingleArticulo } from 'lib/react-query/queriesArticulos'

const ArticuloRowAdmin = ({ articulo, highlightInactive = false }) => {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [openModal, setIsOpenModal] = useState(false)
  const { mutateAsync: updateArticulo } = useUpdateSingleArticulo()

  const handleOnClickDisable = () => {
    updateArticulo({ id: articulo._id, active: true })
  }

  const handleOnClickEnable = () => {
    updateArticulo({ id: articulo._id, active: false })
  }

  return (
    <>
      <tr
        className={`fabrica-table-header fabrica-table-header--not-pointer ${highlightInactive ? 'row-inactivo' : ''}`}
      >
        <td>{articulo?.code}</td>
        <td>{articulo?.name}</td>
        <td className="ta-right">
          {formatToDecimal(articulo?.price || 0, { max: 4, min: 0 })}€
        </td>
        <td className="ta-right">{articulo?.unit}</td>
        <td className="container-buttons-row-articulo">
          <Dropdown
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            button={
              <CustomButton
                type="secondary"
                className="button-edit-articulo-price button-not-hover-bg"
                onClick={() => setIsOpen(prev => !prev)}
              >
                <MoreVertIcon />
              </CustomButton>
            }
          >
            <DropDownItem
              item="Editar artículo"
              onClick={() =>
                navigate(`/admin/articulos/edit-articulo/${articulo._id}`)
              }
            ></DropDownItem>
            {articulo.active === false ? (
              <DropDownItem
                item="Habilitar artículo"
                onClick={() => handleOnClickDisable()}
              />
            ) : (
              <DropDownItem
                item="Deshabilitar artículo"
                onClick={() => handleOnClickEnable()}
              />
            )}
            <DropDownItem
              item="Eliminar artículo"
              onClick={() => setIsOpenModal(true)}
            ></DropDownItem>
          </Dropdown>
        </td>
      </tr>

      {openModal && (
        <ModalDeleteArticuloAdmin
          handleOnClose={() => setIsOpenModal(false)}
          articulo={articulo}
        />
      )}
    </>
  )
}

export default ArticuloRowAdmin
